import { useState } from "react";
import { useLocation } from "react-router-dom";
import Credin from "../../../../../../../../../assets/Credin Logo (1).svg";
import axios from "axios";
import { url } from "../../../../../../../../../App";

export default function FrontPage() {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const name = queryParams.get("name");
  const loanId = queryParams.get("loanId");
  const id = queryParams.get("meetingId");
  const userName = queryParams.get("Username");

  const [isChecked, setIsChecked] = useState(false);
  const [permissionsGranted, setPermissionsGranted] = useState({
    camera: false,
    microphone: false,
    location: false,
  });

  const [permissionRequested, setPermissionRequested] = useState(false);


  const requestPermissions = async () => {
    setPermissionRequested(true);

    let cameraGranted = false;
    let micGranted = false;


    try {
      if (navigator.permissions) {
        const camPerm = await navigator.permissions.query({ name: "camera" });
        const micPerm = await navigator.permissions.query({ name: "microphone" });

        cameraGranted = camPerm.state === "granted";
        micGranted = micPerm.state === "granted";
      }
    } catch (err) {
      console.warn("Permissions API failed, falling back to getUserMedia");
    }

// Fallback /
    if (!cameraGranted || !micGranted) {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({
          video: { facingMode: "user" },
          audio: true,
        });

        cameraGranted = true;
        micGranted = true;


        stream.getTracks().forEach(track => track.stop());
      } catch (err) {
        alert("Camera or microphone permission denied");
        console.error(err);
        return;
      }
    }

    // 3️⃣ Location Permission
    navigator.geolocation.getCurrentPosition(
      () =>
        setPermissionsGranted({
          camera: cameraGranted,
          microphone: micGranted,
          location: true,
        }),
      () =>
        setPermissionsGranted({
          camera: cameraGranted,
          microphone: micGranted,
          location: false,
        })
    );
  };


  const handleCheckboxChange = async (e) => {
    setIsChecked(e.target.checked);
    try {
      const response = await axios.post(`${url}/videosdk/consent`, {
        loan_Id: loanId,
        consentGiven: e.target.checked,
      });

      if (!response.data.auth) {
        console.error("Consent not saved");
      }
    } catch (error) {
      console.error("Error saving consent:", error);
    }
  };

  const openVideoTab = () => {
    if (
      permissionsGranted.camera &&
      permissionsGranted.microphone &&
      permissionsGranted.location
    ) {
      window.open(
        `/vpd/join/pd?meetingId=${id}&name=${name}&Username=${userName}&loanId=${loanId}`,
        "_blank"
      );
    } else {
      alert("Please allow camera, microphone, and location permissions to continue.");
    }
  };


  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        padding: "20px",
      }}
    >
      <img src={Credin} alt="Credin Logo" style={{ marginBottom: "20px" }} />
      <p>Start your loan journey</p>

      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          margin: "20px 0",
        }}
      >
        <label>I hereby give my consent for Video PD &nbsp;</label>
        <input type="checkbox" onChange={handleCheckboxChange} checked={isChecked} />
      </div>

      {isChecked && !permissionRequested && (
        <button
          style={{
            backgroundColor: "#034ea1",
            color: "white",
            padding: "10px 20px",
            borderRadius: "5px",
            border: "none",
            cursor: "pointer",
          }}
          onClick={requestPermissions}
        >
          Allow Camera, Microphone & Location
        </button>
      )}

      {isChecked && permissionRequested && (
        <button
          style={{
            backgroundColor: "#034ea1",
            color: "white",
            padding: "10px 20px",
            borderRadius: "5px",
            border: "none",
            cursor: "pointer",
            marginTop: "10px",
          }}
          onClick={openVideoTab}
        >
          Continue
        </button>
      )}
    </div>
  );
}